import { makeStyles } from "@material-ui/core/styles";
import mobileMenuHeader from "../assets/image/mobileMenuHeader.svg";
import { wrap } from "lodash";

const useStyles = makeStyles((theme) => ({
  //=====================================================================================================================
  //Header style
  //=====================================================================================================================
  headerContainer: {
    padding: "30px 0px 0px 0px",
    backgroundColor: "transparent",
  },
  headerContainer2: {
    background: "linear-gradient(100deg, #1b6fbe -11%, #0ebca0 85%)",
    margin: "0 20px",
    marginTop: 30,
  },
  headerBox: {
    // backgroundColor: "#0000002e",
    zIndex: 2,
    minHeight: 90,
  },
  HomeIcon: {
    width: 45,
    marginLeft: 30,
    marginRight: 30,
    cursor: "pointer",
  },
  logo: {
    marginLeft: 35,
    width: 77,
  },
  headerRightSection: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
  },
  //menu
  menuContainer: {
    flex: 1,
  },
  menuItem: {
    color: "#fff",
    fontSize: 15,
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: 40,
    display: "flex",
    alignItems: "center",
    position: "relative",
    textDecoration: "none",
    userSelect: "none",
    transition: "background-color 0.3s linear",
    "&:hover": {
      backgroundColor: "#fff",
      color: "#000",
      borderRadius: 40,
    },
  },
  electionPopupInHeader: {
    width: 190,
    backgroundColor: "#fff",
    borderRadius: 7,
    position: "absolute",
    top: 35,
    left: 0,
  },
  electionMenuItem: {
    color: "#000",
    padding: "10px",
    textAlign: "center",
    fontSize: 14,
    borderBottom: "1px solid #00000040",
    "&:last-child": {
      border: "none",
    },
  },
  menuAccordionRoot: {
    width: "100%",
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "5px 0",
    },
    "& .MuiButtonBase-root.MuiAccordionSummary-root": {
      backgroundColor: "#c1c1c160",
    },
  },
  verticalLine: {
    width: 1,
    height: 27,
    backgroundColor: "#ffffff8a",
    position: "relative",
  },
  es5Container: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  es5: {
    position: "relative",
    width: 40,
    margin: "0 10px",
  },
  //login $ sign up
  LoginSignUpContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    padding: "10px 30px",
    gap: "10px",
    borderRadius: 30,
    marginRight: "0px",
  },
  fontSize12: {
    fontSize: "12px !important",
    fontWeight: "bold !important",
  },
  loginButton: {
    color: "#cdd6dd !important",
    borderRadius: "4px !important",
    padding: "0px !important",
    minWidth: "max-content",
    "&:hover": {
      // boxShadow: "0 0 8px 6px #0707074a !important",
      // transform: "scale(1.03) !important",
      backgroundColor: "transparent !important",
    },
  },
  signUpButton: {
    backgroundColor: "#fff !important",
    color: "#000 !important",
    borderRadius: "16px !important",
    textAlign: "center !important",

    "&:hover": {
      backgroundColor: "#fff !important",
      boxShadow: "0 0 8px 6px #0707074a !important",
      transform: "scale(1.03) !important",
    },
  },
  //Drawer Mobile
  drawerMenuPaper: {
    backgroundColor: "#f1f1f1",
    width: "fit-Content",
    minWidth: 240,
    maxWidth: 310,
  },
  drawerHeaderContainer: {
    backgroundImage: `url(${mobileMenuHeader})`,
    backgroundSize: "cover",
  },
  avatarAndNameContainer: {
    padding: "10px 10px 15px 15px",
  },
  drawerAvatar: {
    width: 60,
    height: 60,
    marginRight: 15,
  },
  userNameDrawer: {
    color: "#fff",
    fontSize: 15,
    fontWeight: "bold",
  },
  "@keyframes roleAnimation": {
    from: { transform: "translate(100%)" },
    to: { transform: "translate(-140%)" },
  },
  userRoleDrawer: {
    color: "#fff",
    fontSize: 13,
    marginTop: 3,
    maxWidth: 100,
    display: "flex",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    animationName: "$roleAnimation",
    animationDuration: "7000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  },

  drawerProfileContainer: {
    borderBottom: "1px solid #d9d9d9",
  },
  drawerMenuItemContainer: {
    padding: "10px 0 10px 0",
    overflowY: "auto",
    overflowX: "hidden",
    flexWrap: "nowrap",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  drawerRow: {
    padding: "5px 25px",
    position: "relative",
    textDecoration: "none",
  },
  rememberCount: {
    color: "#fff",
    width: 24,
    height: 24,
    padding: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100%",
    backgroundColor: "red",
    textAlign: "center",
    position: "absolute",
    right: 20,
  },
  rememberCollapseContainer: {
    backgroundColor: "#e8e8e8",
    padding: 10,
  },
  drawerItem: {
    fontSize: 15,
    color: "#413f3f",
    marginLeft: 20,
    padding: 5,
    textDecoration: "none",
  },
  drawerItem2: {
    fontSize: 15,
    color: "#413f3f",
    padding: 5,
    paddingLeft: 20,
    textDecoration: "none",
    backgroundColor: "#e8e8e8",
    marginBottom: 10,
  },
  arrowDownDrawer: {
    color: "#7f7f7f",
    transition: "transform 0.3s ease-out",
  },
  arrowUpDrawer: {
    color: "#7f7f7f",
    transform: "rotate(-180deg)",
    transition: "transform 0.3s ease-out",
  },
  rememberItem: {
    padding: "10px 0px 5px 70px",
  },
  notificationFade: {
    width: 190,
    borderRadius: 14,
    backgroundColor: "#fff",
    position: "absolute",
    left: 0,
    top: 50,
    paddingTop: 10,
    maxHeight: 700,
    overflow: "hidden",
  },
  notificationItem: {
    cursor: "pointer",
    padding: "8px 10px",
    borderBottom: "1px solid #eee",
    "&:last-child": {
      border: "none",
    },
    "&:hover": {
      backgroundColor: "#eee",
    },
  },
  notificationTitle: {
    paddingBottom: 4,
  },
  allNotification: {
    overflowY: "auto",
  },
  seeMore: {
    padding: "10px",
    backgroundColor: "#29b8b2",
    color: "#fff",
    borderBottom: "1px solid #2588b794",
    cursor: "pointer",
  },
  setSeenAll: {
    padding: "10px",
    backgroundColor: "#2aa2b8",
    color: "#fff",
    cursor: "pointer",
  },
  //search
  searchContainer: {
    width: "fit-content",
    position: "relative",
  },
  searchInput: {
    borderRadius: "20px",
    backgroundColor: "#27212130",
    padding: 10,
    borderStyle: "solid",
    border: "0",
    fontFamily: "iranSans",
    fontSize: "16px",
    width: 140,
    transition: "width 200ms ease-out",
    paddingRight: 45,
    color: "#fff",
    "&:focus": {
      outline: "none",
      width: 290,
    },
    "&::placeholder": {
      color: "#ffffff",
    },
    "@media(min-width:1366px)": {
      "&:focus": {
        outline: "none",
        width: 290,
      },
    },
  },
  activeInput: {
    borderRadius: "20px",
    backgroundColor: "#27212130",
    padding: 10,
    borderStyle: "solid",
    color: "#fff",
    border: "0",
    fontFamily: "iranSans",
    fontSize: "16px",
    width: 290,
    transition: "width 200ms ease-out",
    "&:focus": {
      outline: "none",
      width: 290,
    },
    "&::placeholder": {
      color: "#ffffff90",
    },
    "@media(min-width:1366px)": {
      width: 290,
      "&:focus": {
        outline: "none",
        width: 290,
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      backgroundColor: "#afafaff2",
      "&:focus": {
        outline: "none",
        width: "100%",
      },
    },
  },
  searchFadeContainer: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    position: "absolute",
    top: 50,
    overflow: "hidden",
    minHeight: 200,
    justifyContent: "space-between",
  },
  searchSection: {
    width: "30%",
    fontSize: "14px",
    padding: "5px",
    borderRadius: "0 0 4px 4px",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "linear-gradient(238deg, #a3a3a3 49%, #f7f7f7 125%)",
    cursor: "pointer",
    userSelect: "none",
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      borderRadius: "20px",
    },
  },
  activeSearchSection: {
    cursor: "default",
    userSelect: "none",
    width: "30%",
    fontSize: "14px",
    padding: "5px",
    borderRadius: "0 0 4px 4px",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "linear-gradient(238deg, #d4145a 17%, #fbb03b 107%)",
    color: "#fff",
    transition: "all 200ms linear",
    [theme.breakpoints.down("sm")]: {
      borderRadius: "20px",
    },
  },
  searchSubmit: {
    backgroundImage: "linear-gradient(242deg, #2d92f6 3%, #10c587 92%)",
    color: "#fff",
    padding: "10px",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      borderRadius: "20px",
    },
  },
  searchSubmitDisabled: {
    backgroundImage: "linear-gradient(238deg, #a3a4a4 149%, #f7f7f7 125%)",
  },
  mobileSearchDialogPaper: {
    width: "100% ",
    backgroundColor: "transparent",
    boxShadow: "none !important",
    padding: "15px",
    margin: 5,
  },
  //profileSection
  ProfileSectionContainer: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    paddingRight: 10,
  },
  ProfileTextContainer: {
    position: "relative",
    color: "#fff",
    top: 19,
    cursor: "pointer",
    marginLeft: 10,
    display: window.innerWidth < 1100 ? "none" : "block",
  },
  profileText: {
    color: "#fff",
  },
  ArrowDown: {
    position: "relative",
    width: 10,
    top: 9,
    transform: "rotate(-90deg)",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
  },
  profileAvatar: {
    width: 60,
    height: 60,
    margin: "0 20px",
    cursor: "pointer",
  },
  ProfileContainer: {
    minWidth: 150,
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 8px 16px 0 rgba(0, 0, 0, 0.16)",
    overflow: "hidden",
    zIndex: 2,
  },
  rectangle: {
    width: 15,
    height: 15,
    backgroundColor: "#fff",
    transform: "rotate(45deg)",
    position: "absolute",
    top: -6,
    right: 30,
  },
  userIcon: {
    fontSize: 16,
    marginRight: 4,
  },
  resetPasswordIcon: {
    width: 15,
    marginRight: 5,
  },
  exitIcon: {
    fontSize: 17,
    marginRight: 4,
  },
  exitContainer: {
    padding: 10,
    cursor: "pointer",
    userSelect: "none",
  },
  nameContainer: {
    padding: 10,
    borderBottom: "1px solid #eee",
  },
  nameText: {
    fontSize: 14,
    color: "#fff",
  },
  exitText: {
    fontSize: 12,
  },
  //mobileHeader
  mobHeaderInsideContainer: {
    position: "fixed",
    top: 9,
  },
  loginSignUpContainer: {
    display: "flex",
    paddingRight: 10,
    paddingTop: 15,
    alignItems: "center",
  },
  mobSignUpButton: {
    borderRadius: "30px !important",
    backgroundColor: "#fff !important",
    fontWeight: "bold !important",
    fontSize: "11px !important",
    height: "25px !important",
    width: "40px !important",
  },
  mobLoginButton: {
    borderRadius: "30px !important",
    fontWeight: "bold !important",
    fontSize: "11px !important",
    height: "25px !important",
    width: "40px !important",
    marginRight: "10px",
    color: "#fff !important",
    borderColor: "#fff !important",
    whiteSpace: "nowrap",
  },
  verticalLineLoginSignUp: {
    height: 24,
    backgroundColor: "#fff",
    margin: "0 10px",
    width: 1,
  },
  welcomeImageHeader: {
    "@media (min-width: 260px)": {
      width: 110,
      marginTop: 30,
    },
    "@media (min-width: 420px)": {
      width: 140,
      marginTop: 50,
    },
    "@media (min-width: 550px)": {
      width: 150,
      marginTop: 70,
    },
    "@media (min-width: 650px)": {
      width: 170,
      marginTop: 70,
    },
    "@media (min-width: 720px)": {
      width: 180,
      marginTop: 90,
    },
  },
  enterElectionCollapse: {
    minHeight: "unset !important",
  },
  //selectBox
  grid: {
    flex: 1,
  },
  gridElection: {
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: 10,
    },
  },
  fieldTitleContainer: {
    display: "flex",
    flexWrap: "nowrap",
    marginBottom: 5,
    [theme.breakpoints.down("sm")]: {
      width: 105,
    },
  },
  SelectBoxRoot: {
    position: "relative",
    userSelect: "none",
    flex: 1,
  },
  selectBoxContainer: {
    flex: 1,
    height: 44,
    backgroundColor: "#fff",
    userSelect: "none",
    borderRadius: 5,
    boxShadow: "0 3px 31px 0 rgba(0, 0, 0, 0.15)",
    padding: "3px 15px",
    fontSize: 13,
    cursor: "pointer",
  },
  arrowDownSelectBox: {
    color: "#707070",
    fontSize: 18,
    position: "absolute",
    right: 15,
    transform: "rotate(90deg)",
  },
  selectBoxFadeContainer: {
    backgroundColor: "#fff",
    height: "fit-content",
    maxHeight: 240,
    boxShadow: "0 3px 31px 0 rgba(0, 0, 0, 0.15)",
    position: "absolute",
    userSelect: "none",
    top: 45,
    borderRadius: 5,
    overflowY: "auto",
    zIndex: 99,
  },
  selectBoxFadeItem: {
    padding: "15px 15px",
    cursor: "pointer",
    fontSize: 15,
    "&:hover": {
      backgroundColor: "#d2d2d2",
    },
  },
  //=====================================================================================================================
  //ّFooter style
  //=====================================================================================================================
  footerContainer: {
    position: "relative",
    minHeight: 230,
    backgroundColor: "#eeeeee",
    overflow: "hidden",
    paddingBottom: 30,
  },
  footerBackground: {
    backgroundColor: "#eeeeee",
    position: "absolute",
    pointerEvents: "none !important",
    bottom:
      window.innerWidth < 1180 && window.innerWidth > 1150
        ? -120
        : window.innerWidth < 1100
        ? -100
        : window.innerWidth > 1439 && window.innerWidth < 1500
        ? -177
        : window.innerWidth > 1499 && window.innerWidth < 1600
        ? -220
        : window.innerWidth > 1599 && window.innerWidth < 1800
        ? -300
        : window.innerWidth > 1799 && window.innerWidth < 1900
        ? -320
        : window.innerWidth > 1899 && window.innerWidth < 2000
        ? -335
        : window.innerWidth > 1999
        ? -370
        : -153,
    width: "100%",
  },
  footerLogo: {
    zIndex: 1,
    height: "120px",
  },
  footerAddressText: {
    color: "#ffffffe8",
    fontSize: 15,
    fontWeight: "bold",
    zIndex: 1,
  },
  verticalLineFooter: {
    width: 1,
    height: 15,
    backgroundColor: "#ffffff9c",
    margin: "0 10px",
    zIndex: 1,
    position: "relative",
    top: 2,
  },
  footerText2: {
    fontSize: 12,
    fontWeight: "bold",
    zIndex: 1,
    color: "#ecf6f8",
    marginTop: 10,
  },
  //mobile footer
  mobFooterData: {
    position: "absolute",
    bottom: 20,
    zIndex: 3,
    "@media (min-width:475px)": {
      bottom: 40,
    },
    "@media (min-width:550px)": {
      bottom: 50,
    },
    "@media (min-width:620px)": {
      bottom: 60,
    },
  },
  mobLogoFooter: {
    width: 60,
    "@media (min-width:300px)": {
      width: 70,
      marginBottom: 10,
    },
    "@media (min-width:375px)": {
      width: 90,
      marginBottom: 10,
    },
    "@media (min-width:475px)": {
      width: 100,
      marginBottom: 13,
    },
    "@media (min-width:620px)": {
      width: 120,
      marginBottom: 15,
    },
  },
  mobAddressFooter: {
    width: 250,
    "@media (min-width:475px)": {
      width: 300,
    },
  },
  mobPhoneNumber: {
    color: "#fff",
    fontWeight: "500",
    fontSize: 14,
  }
}));
export default useStyles;
